module.exports = __webpack_public_path__ + "95cd33d6a0fb46dc7a6283e9f12e7151.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/logo.png
// module id = 314
// module chunks = 0